import Contenido from './components/Contenido'

export default function PaginaPublica() {
  return <Contenido />
}
